import * as React from 'react';
import { Link } from 'react-router-dom';
const classNames = require('classnames');

import { SectionRight } from '../sections';
import { IconBrand, IconFacebook, IconTwitter, IconInstagram, IconLinkedIn } from '../icons';

interface Props {
	title?: {};
	className?: string;
	children?: {};
	fluid?: boolean;
}

const PageFooter: React.StatelessComponent<Props> = ({ fluid = false, title, className, children }) => {
	return (
		<footer className={classNames('page-footer no-print', className)}>
			<div className={fluid ? 'container-fluid' : 'container'}>
				<div className="row">
					<div className="col-lg-3 mb-3 mb-lg-0">
						<Link to="/" className="text-secondary page-footer-brand">
							<IconBrand />
						</Link>
						<small className="d-block mt-1 mt-md-3 text-muted">Version {process.env.REACT_APP_Version}</small>
						<div className="col-12 float-left mt-2 pl-0">
							<a href="https://www.facebook.com/insuredbymosaic/" target="_blank" className="pr-2">
								<IconFacebook/>
							</a>
							<a href="https://twitter.com/insuredbymosaic" target="_blank" className="pr-2">
								<IconTwitter/>
							</a>
							<a href="https://www.instagram.com/_insuredbymosaic/" target="_blank" className="pr-2">
								<IconInstagram/>
							</a>
							<a href="https://www.linkedin.com/company/19011371/" target="_blank">
								<IconLinkedIn/>
							</a>
						</div>
					</div>
					<div className="col-md-4 col-lg-3">
						<ul className="list-unstyled">
							<li>
								<Link to="/quote/A/about-you" className="page-footer-link">
									<strong>Get an easy quote</strong>
								</Link>
							</li>
							<li>
								<Link to="/faq" className="page-footer-link">
									FAQ
								</Link>
							</li>
							<li>
								<Link to="/claims" className="page-footer-link">
									Make a claim
								</Link>
							</li>
							<li>
								<Link to="/quote/B/about-you" className="page-footer-link">
									Advisory calculator
								</Link>
							</li>
						</ul>
					</div>
					<div className="col-md-4 col-lg-3">
						<ul className="list-unstyled">
							<li>
								<Link to="/about-us" className="page-footer-link">
									About mosaic life
								</Link>
							</li>
							<li>
								<a href="https://blog.insuredbymosaic.ca" className="page-footer-link">
									Blog
								</a>
							</li>
							<li>
								<Link to="/privacy" className="page-footer-link">
									Privacy policy
								</Link>
							</li>
							<li>
								<Link to="/terms" className="page-footer-link">
									Terms of use
								</Link>
							</li>
						</ul>
					</div>
					<SectionRight
						columns={12}
						sectionClassName="p-4"
						wrapperClassName="col-md-4 col-lg-3 pl-md-0 footer-contact-section"
					>
						<ul className="list-unstyled text-md-right mb-0">
							<li className="d-block pt-2 page-footer-link">
								<h2 className="h3 mb-0">Have questions?</h2>
							</li>
							<li className="page-footer-link">
								Call us at <strong className="text-primary" ><a href="tel:1-855-643-6945">1-855-643-6945</a></strong>
							</li>
							<li>
								<Link to="/contact-us" className="page-footer-link">
									Contact us
								</Link>
							</li>
							{/*
							<li>
								<button id="footer-intercom-link" type="button" className="btn btn-link page-footer-link">
									Chat with us
								</button>
							</li>
							*/}
						</ul>
					</SectionRight>
				</div>
				{children}
			</div>
		</footer>
	);
};

export default PageFooter;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/common/PageFooter.tsx